module.exports = __webpack_public_path__ + "img/restitution-administratif.2b8d1224.png";